import { useTranslation } from 'react-i18next'
import { Modal, Typography } from 'antd'
import { CloseOutlined } from '@ant-design/icons'
import guideHero from './images/guide-hero-73b71f.png'

interface FirstVisitGuideModalProps {
  open: boolean
  onClose: () => void
  onCreate: () => void
}

function FirstVisitGuideModal({ open, onClose, onCreate }: FirstVisitGuideModalProps) {
  const { t } = useTranslation()

  const steps = [
    {
      n: '1',
      title: t('workbench.guideStep1Title'),
      desc: t('workbench.guideStep1Desc'),
    },
    {
      n: '2',
      title: t('workbench.guideStep2Title'),
      desc: t('workbench.guideStep2Desc'),
    },
    {
      n: '3',
      title: t('workbench.guideStep3Title'),
      desc: t('workbench.guideStep3Desc'),
    },
  ]

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      closable={false}
      width={720}
      centered
      destroyOnHidden
      styles={{
        container: {
          padding: 0,
          overflow: 'hidden',
          borderRadius: 14,
          border: '1px solid #DCDCDC',
          background: '#E4E6F6',
          boxShadow: '0px 16px 22px -6px rgba(28, 28, 28, 0.16)',
        },
        body: { padding: 0 },
      }}
    >
      <div className="relative">
        <div className="relative h-[220px] overflow-hidden rounded-t-[14px]">
          <div className="absolute inset-0 bg-gradient-to-b from-[#E4E6F6] to-transparent" />
          <img
            src={guideHero}
            alt=""
            className="absolute inset-0 h-full w-full object-cover"
          />
          <button
            type="button"
            aria-label="close"
            onClick={onClose}
            className="absolute right-5 top-3.5 flex h-5 w-5 items-center justify-center text-black/60 hover:text-black"
          >
            <CloseOutlined />
          </button>
        </div>

        <div className="flex flex-col gap-2.5 px-10 pb-6 pt-2.5">
          <div className="flex flex-col items-center gap-1 text-center">
            <Typography.Title level={3} className="!mb-0 !text-2xl !font-medium !text-black">
              {t('workbench.guideTitle')}
            </Typography.Title>
            <Typography.Text className="!text-[15px] !leading-6 !text-black/60">
              {t('workbench.guideSubtitle')}
            </Typography.Text>
          </div>

          <div className="mt-2 flex flex-col gap-2.5">
            {steps.map((step) => (
              <div
                key={step.n}
                className="rounded-[18px] bg-white/85 px-5 py-4"
              >
                <div className="flex gap-4">
                  <div className="flex h-6 w-6 shrink-0 items-center justify-center rounded-[14px] bg-[#6366F1] text-xs font-semibold text-white">
                    {step.n}
                  </div>
                  <div>
                    <Typography.Text className="!block !text-base !font-medium !text-black">
                      {step.title}
                    </Typography.Text>
                    <Typography.Text className="!text-[13px] !leading-5 !text-black/60">
                      {step.desc}
                    </Typography.Text>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-2 flex justify-center">
            <button
              type="button"
              onClick={onCreate}
              className="flex h-[42px] items-center justify-center rounded-lg bg-[#6366F1] px-12 text-sm font-medium text-white hover:bg-[#5558e6]"
            >
              {t('workbench.guideCta')}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default FirstVisitGuideModal
